import KubewardenModel from '../plugins/kubewarden/policy-class';

export default class ClusterAdmissionPolicy extends KubewardenModel {
}
